
import React, { useState,useEffect  } from 'react';
import Developing from "layouts/Developing"

export function  Delivery(){
    return (
        <div style={{padding: '30px 33px 33px 31px'}}>
            <Developing />
        </div>
    )
}
